import apiConfigs from 'app/configs/apiConfigs'

export const fontSizeOptions = [
  { value: '12px', label: '12px' },
  { value: '14px', label: '14px' },
  { value: '16px', label: '16px' },
  { value: '18px', label: '18px' },
  { value: '20px', label: '20px' },
  { value: '24px', label: '24px' },
  { value: '30px', label: '30px' },
  { value: '48px', label: '48px' },
  { value: '60px', label: '60px' },
  { value: '72px', label: '72px' },
  { value: '96px', label: '96px' },
]

export const lineHeightOptions = [
  { value: '1', label: 'Single' },
  { value: '1.15', label: '1.15' },
  { value: '1.5', label: '1.5' },
  { value: '2', label: 'Double' },
]

export const ContentTypes = {
  'application/pdf': 'pdf',
  'application/zip': 'zip',
  'application/octet-stream': 'md',
  'text/csv': 'csv',
  'text/rtf': 'rtf',
  'text/plain': 'txt',
  'text/markdown': 'md',
  'text/html': 'html',
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'docx',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.ms-excel.sheet.macroEnabled.12': 'xlsm',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.ms-powerpoint': 'ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    'pptx',
  'video/mp4': 'mp4',
  'audio/mpeg': 'mp3',
  'audio/wav': 'wav',
  'image/jpg': 'jpg',
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/gif': 'gif',
  'image/bmp': 'bmp',
  'image/svg+xml': 'svg',
  'image/webp': 'webp',
}

export const VALIDATION_CONFIG = {
  image: {
    maxSize: 25 * 1024 * 1024,
    types: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'],
  },
  video: { maxSize: 50 * 1024 * 1024, types: ['video/mp4'] },
  file: { maxSize: 50 * 1024 * 1024, types: Object.keys(ContentTypes) },
}

export const normalizeEmptyParagraphs = (html) =>
  html?.replace(/<p([^>]*)>\s*<\/p>/g, '<p$1><br></p>')

export const addImageKitToBaseUrl = (path) => {
  return `${apiConfigs.cndUrl}/${path}`
}

export const getFontFamily = (defaultFont) => {
  const fontFamilies = [
    { value: 'Arial', label: 'Arial' },
    { value: 'Calibri', label: 'Calibri' },
    { value: 'Courier New', label: 'Courier New' },
    { value: 'Georgia', label: 'Georgia' },
    { value: 'Open Sans', label: 'Open Sans' },
    { value: 'Roboto', label: 'Roboto' },
    { value: 'Roboto Mono', label: 'Roboto Mono' },
    { value: 'Roboto Serif', label: 'Roboto Serif' },
    { value: 'Times New Roman', label: 'Times New Roman' },
    { value: 'Verdana', label: 'Verdana' },
  ]

  return fontFamilies.find((font) => font.value === undefined)
    ? [{ value: defaultFont, label: defaultFont }, ...fontFamilies]
    : fontFamilies
}

export const denormalizeEmptyParagraphs = (html) =>
  html?.replace(/<p([^>]*)>\s*<br\s*\/?>\s*<\/p>/g, '<p$1></p>')

export const applyImageStyling = (html) => {
  return (
    html
      .replace(/\s(width|height)="[^"]*"/g, '')

      // Images with a style attribute
      .replace(
        /<img([^>]*?)style="([^"]*?)"([^>]*?)>/g,
        (match, pre, style, post) => {
          const widthMatch = style.match(/width\s*:\s*(\d+)px/)
          const maxWidthMatch = style.match(/max-width\s*:\s*(\d+)px/)
          const heightMatch = style.match(/height\s*:\s*(\d+)px/)

          // Check if image has width > 600px and needs responsive treatment
          const shouldReplace =
            (widthMatch && parseInt(widthMatch[1], 10) > 600) ||
            (maxWidthMatch && parseInt(maxWidthMatch[1], 10) > 600)

          if (shouldReplace) {
            // Remove existing width/height/max-width and make responsive
            const cleanStyle = style
              .replace(/max-width\s*:\s*[^;]+;?/g, '')
              .replace(/width\s*:\s*[^;]+;?/g, '')
              .replace(/height\s*:\s*[^;]+;?/g, '')
              .replace(/;\s*$/, '')

            const newStyle =
              `width: auto; max-width: 100%; height: auto; cursor: pointer; ${cleanStyle}`.trim()

            return `<img${pre}style="${newStyle}"${post}>`
          }

          // Check if image lacks width AND height properties
          const hasWidth = widthMatch || maxWidthMatch
          const hasHeight = heightMatch

          if (!hasWidth && !hasHeight) {
            const cleanStyle = style.replace(/;\s*$/, '')
            const newStyle = `${cleanStyle}; width: auto; max-width: 100%; height: auto; cursor: pointer`

            return `<img${pre}style="${newStyle}"${post}>`
          }

          return match
        },
      )

      // Images WITHOUT a style attribute - always add responsive styling
      .replace(/<img([^>]*?)(?<!style="[^"]*")>/g, (match, attrs) => {
        return `<img style="width: auto; max-width: 100%; height: auto; cursor: pointer;"${attrs}>`
      })

      .replace(/<img class="ProseMirror-separator" alt="">/g, '')
  )
}

export const removeImageKitStyle = (html) => {
  return html.replace(/style="([^"]*?)"/g, (match, styleContent) => {
    const cleanedStyles = styleContent
      .split(';')
      .filter((declaration) => {
        const trimmed = declaration.trim()
        return trimmed && !trimmed.startsWith('--tw')
      })
      .join('; ')

    return cleanedStyles.trim() ? `style="${cleanedStyles}"` : ''
  })
}
